import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { ContactUsService } from '../../../api/contactus/contactus.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'contactus-page',
    templateUrl: './contactus.html'
})
export class ContactUsComponent implements OnInit {
    contactus = []
    id: any;
    index: any
    answerby: any
    constructor(private contactusservice: ContactUsService,
        private router: Router) {
    }
    ngOnInit() {
        this.contactusservice.getallcontactus().then(data => {
            this.contactus = data
        })
    }
    openDelete(i, key) {
        this.id = key;
        this.index = i;
    }
    cancelAction() {
    }
    DeleteKeyword() {
        this.contactusservice
            .ddata(this.id)
            .then(data => {
                if (data) {
                    if (data.status) {
                        $(function () {
                            $('#deletekeyword').modal('toggle');
                        });
                        this.contactus.splice(this.index, 1);
                    }
                }
            });
    }
    checkanswerby(id, isanswerby, i) {
        var j = i
        this.answerby = isanswerby
        if (this.answerby == 0) {
            this.answerby = 1;
        }
        var data = {
            answerby: this.answerby
        };
        this.contactusservice
            .contactanswer(id, data)
            .then(data => {
                if (data) {
                    if (data.status) {
                        this.contactus[j].answerby = data.data.answerby;
                    }
                }
            });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/contactus/contactus.page.ts